<template>
  <el-form
    ref="form"
    label-position="top"
    :model="form"
    :rules="rules"
    @submit.native.prevent="submit"
  >
    <h1>Konto verwalten</h1>

    <el-form-item>
      <c-button-link
        round
        :to="{ name: 'account-password' }"
      >
        Passwort ändern
      </c-button-link>
    </el-form-item>

    <c-account-form-email
      :form="form"
      :errors="errors"
    />

    <el-form-item>
      <el-button
        type="primary"
        native-type="submit"
        round
      >
        Speichern
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import CAccountFormEmail from '@/components/CAccountFormEmail'
import CButtonLink from '@/components/CButtonLink'

import api from '@/api'

export default {
  name: 'VAccountAdmin',

  metaInfo: {
    title: 'Konto verwalten'
  },

  components: {
    CAccountFormEmail,
    CButtonLink
  },

  data () {
    return {
      form: {
        email: this.$store.state.user.profile.email
      },
      errors: {
        email: []
      },
      rules: {
        email: {
          required: true,
          type: 'email',
          message: 'Bitte geben Sie eine E-Mail-Adresse ein.'
        }
      }
    }
  },

  methods: {
    resetErrors () {
      this.errors.email = []
    },
    submit () {
      this.resetErrors()

      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }

        this.submitStatus = this.$config.status.LOADING

        api.admin
          .update(this.$store.state.user.profile.id, this.form)
          .then(() => {
            this.$notify.success({
              title: 'Konto aktualisiert',
              message: 'Ihr Konto wurde erfolgreich aktualisiert.'
            })

            this.submitStatus = this.$config.status.SUCCESS
            this.$router.push({ name: 'index' })
          })
          .catch(() => {
            this.$notify.error({
              title: 'Fehler',
              message: 'Ihr Profil konnte leider nicht aktualisiert werden.'
            })

            this.submitStatus = this.$config.status.ERROR
          })
      })
    }
  }
}
</script>
